exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress {\n  background-color: #CBDB29;\n  height: 4px;\n  border-radius: 5px; }\n\n.bar {\n  background-color: #EFF0F4;\n  border-radius: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/upload-progress-bar/upload-progress-bar.component.scss
// module id = ../../../../../src/app/shared/components/upload-progress-bar/upload-progress-bar.component.scss
// module chunks = 12